import { useState } from "react";
import { Toast, ToastBody } from "reactstrap";
import { Btn, Image } from "../../../../AbstractElements";
import { TopRightToastTitle } from "../../../../Constants/Constants";
import { dynamicImage } from "../../../../Utils";

const TopRightToast = () => {
  const [visible, setVisible] = useState(false);
  const toggle = () => setVisible(!visible);
  const handleClick = () => {
    setVisible(true);
    setTimeout(() => setVisible(false), 8000);
  };
  return (
    <>
      <Btn color="primary" onClick={handleClick}>
        {TopRightToastTitle}
      </Btn>
      <div className="toast-container position-fixed top-0 end-0 p-3 toast-index toast-rtl">
        <Toast fade isOpen={visible} toggle={toggle}>
          <div className="toast-img toast-header">
            <Image className="rounded me-2" src={dynamicImage(`product-lists/profile.png`)} alt="profile" />
            <strong className="me-auto">{"Berlin Theme"}</strong>
            <small>{"5 min ago"}</small>
            <Btn close className="p-0" onClick={toggle}></Btn>
          </div>
          <ToastBody className="toast-dark">{"Hello, I'm a web-designer."}</ToastBody>
        </Toast>
      </div>
    </>
  );
};
export default TopRightToast;
